import React, { ReactNode } from 'react';

import * as S from './styles';

interface IProps {
  children: ReactNode;
  className?: string;
}

/**
 * The design's `.add-divider` — an add button with a rule running out to each
 * side.
 *
 *   <AddDivider>
 *     <button type="button" onClick={addOption}>
 *       <PlusIcon /> Add option
 *     </button>
 *   </AddDivider>
 *
 * The rules are what make it read as *between* things rather than as another
 * control in the stack: it always adds one more of whatever is above it, and
 * it is always the last thing in that group.
 *
 * Pass a bare `<button>`; the styling comes from here, so every repeatable
 * section in the product gets the same object. The survey and notification
 * builders are the other two the design draws it on.
 */
const AddDivider: React.FC<IProps> = ({ children, className }) => (
  <S.AddDivider className={className}>{children}</S.AddDivider>
);

export default AddDivider;
